const actions = {
  setSfwMode(context, paranoiaLevel) {
    context.commit('SET_SFW_MODE', Number(paranoiaLevel));
  },

  setBobIndexes(context, val) {
    context.commit('SET_BOB_INDEXES', val);
  },
};

export default actions;
